import { render, staticRenderFns } from "./fila_consultas.vue?vue&type=template&id=3cd66fdd"
import script from "./fila_consultas.vue?vue&type=script&lang=js"
export * from "./fila_consultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports